import '@mdi/font/css/materialdesignicons.css'
import { createVuetify, ThemeDefinition } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles' //Only component styles are included, global styles must be imported separately from 'vuetify/styles'.

const light: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#F9F9F9',
    surface: '#FFFFFF',

    primary: '#009FE3', // CTA
    secondary: '#F8DEAE',
    'itemis-analyze-primary': '#F59E00',
    'itemis-analyze-secondary': '#F8DEAE',
    'itemis-analyze-grey': '#90a7b2',
    'itemis-analyze-dark': '#CF7A2C',
    'font-color': '#001935',
    'font-color-headline': '#00457C',
    'grey-dark': '#808080',
    'grey-medium': '#CCCCCC',
    'grey-light': '#F0F0F0',
    'itemis-hidden-grey': '#ADADAD',
    'cyan-dark': '#004771',

    error: '#FF0000',
    info: '#009FE3',
    success: '#58C863',
    warning: '#FFB930',
  },
}

if (light.colors) {
  light.colors['on-background'] = light.colors['font-color']
  light.colors['on-surface'] = light.colors['font-color']
  light.colors['on-primary'] = light.colors['surface']
  light.colors['on-secondary'] = light.colors['surface']
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light,
    },
  },
})
